var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2264 16.188L14.2083 20.1667L16.5 19.25L18.7917 20.1667L17.875 16.1321M19.25 13.75C19.25 15.2688 18.0188 16.5 16.5 16.5C14.9812 16.5 13.75 15.2688 13.75 13.75C13.75 12.2312 14.9812 11 16.5 11C18.0188 11 19.25 12.2312 19.25 13.75Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.16668C18.3333 5.70971 18.3333 3.98123 17.2593 2.90728C16.1854 1.83334 14.4569 1.83334 10.9999 1.83334H10.0834C6.62643 1.83334 4.89795 1.83334 3.82401 2.90727C2.75007 3.9812 2.75006 5.70967 2.75003 9.16661L2.75 12.8333C2.74997 16.2903 2.74995 18.0187 3.82389 19.0927C4.89784 20.1667 6.62634 20.1667 10.0834 20.1667H11.9166",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.41666H14.2083M6.875 11H11",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy-policy.0c6245a910298f910c7a3b13a1828729.svg";
export { ForwardRef as ReactComponent };